import React, { Component } from "react";
import { connect } from "react-redux";
import { increaseStepByOne } from "../../actions";
import { Button } from '../ui';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    paddingTop: '25px'
  },
  button: {
    padding: '5px 10px'
  }
}

class Hire extends Component {

  onContinue = () => {
    const { 
      onContinueClick, 
      onHireClick 
    } = this.props;
    onContinueClick();
    if(onHireClick !== null) onHireClick();
  } 

  render() {

    const { 
      onThinkClick, 
      thinkText, hireText
    } = this.props;

    return (
      <div style={styles.container}>
        <div style={styles.button}>
          <Button
            onClick={() => {onThinkClick()}}
            onKeyPress={() => {onThinkClick()}}
            disabled={!onThinkClick}
          >
            {thinkText}
          </Button>
        </div>
        <div style={styles.button}>
          <Button 
            onClick={this.onContinue}
            onKeyPress={this.onContinue}
          >
            {hireText}
          </Button>
        </div>
      </div>
    );
  }
}

Hire.defaultProps = {
  hireText: 'Contratar', 
  thinkText: 'Lo voy a pensar', 
  onHireClick: null,
  onThinkClick: null
};

const mapDispatchToProps = dispatch => {
  return {
    onContinueClick: () => {
      dispatch(increaseStepByOne());
    },
  };
};

export default connect(null, mapDispatchToProps)(Hire);